/**
 * set dom element sticky relative to parent container for .s-sticky-panel selectors
 */
import jQuery from 'jquery'
import Breakpoint from 'bootstrap-breakpoints'

export const scrDevices = () => {
  Breakpoint.init()
  return Breakpoint.is('sm') || Breakpoint.is('xs')
}

class AsideStickyOnScroll {
  constructor(element, element2, thresholdElementOffset) {
    if ((!element, !element2)) {
      return false
    }

    this.$element = element
    this.$element2 = element2
    this.$offset = thresholdElementOffset
    this.$stickyRibbon = jQuery('.s-milesNBonus-ribbon')

    jQuery(window).on('resize', () => {
      this.ini()
    })

    jQuery(window).on('scroll', () => {
      this.ini()
    })
  }

  ini() {
    if (scrDevices()) {
      return false
    }

    const stickyElement = jQuery(this.$element)
    const thresholdElement = jQuery(this.$element2)

    const scrollTop = jQuery(window).scrollTop()
    const parentOffsetTop = stickyElement.parent().offset().top
    const parentHeight = stickyElement.parent().outerHeight() - 30
    const stickyHeight = stickyElement.outerHeight()
    let distanceFromTop = 100

    const ribbonHeight = this.$stickyRibbon.outerHeight()
    if (this.$stickyRibbon.length) {
      distanceFromTop = distanceFromTop + ribbonHeight
    } else {
      distanceFromTop = 100
    }

    const heightFromBottom = 0

    let formHeight = 0
    jQuery('.s-booking-layout__main')
      .children()
      .each(function () {
        formHeight += jQuery(this).outerHeight()
      })

    const asideHeight =
      jQuery('.b-booking-aside__top-section').height() +
      jQuery('.b-booking-aside__main').height()

    if (formHeight <= asideHeight) {
      return
    }

    let dif = 0
    if (this.$offset > 0) {
      dif =
        jQuery(thresholdElement).offset().top -
        jQuery('header').outerHeight() +
        this.$offset
    } else {
      dif =
        jQuery(thresholdElement).offset().top -
        jQuery('header').outerHeight() +
        jQuery(thresholdElement).outerHeight()
    }

    if (
      scrollTop > dif &&
      scrollTop <
        parentOffsetTop +
          parentHeight -
          stickyHeight -
          heightFromBottom -
          distanceFromTop
    ) {
      stickyElement.css({
        position: 'fixed',
        top: distanceFromTop,
        width: jQuery(thresholdElement).outerWidth(),
      })
    } else if (
      scrollTop >=
      parentOffsetTop +
        parentHeight -
        stickyHeight -
        heightFromBottom -
        distanceFromTop
    ) {
      stickyElement.css({
        position: 'absolute',
        top: parentHeight - stickyHeight - heightFromBottom,
      })
    } else {
      stickyElement.css({
        position: 'relative',
        top: 0,
        width: 'unset',
      })
    }
  }
}
export default AsideStickyOnScroll
